// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__12F9Q","bigColWidth":"Table_bigColWidth__GZmWO","biggerColWidth":"Table_biggerColWidth__1n4AO","row":"Table_row__MpiYt","col":"Table_col__3g3SH"};